//#region Libraries
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { Container, PeriodDate } from "./styles";
//#endregion
//#region Components
import DataField from "views/components/Detail/DataField/DataField";
//#endregion
//#region Utils
import { 
    getTextTimeByMinutes
} from "components/CustomTimePicker/utils";
import { getDatePartsByMillis, getDayIdByTimestamp, MONTHS, WEEK_DAYS } from "components/CustomDatePicker/utils/helpers";
import InactivityDataFields from "./components/InactivityDataFields/InactivityDataFields";
//#endregion

const hasInactivity = time => {
    return time.some(({ inactivity }) => inactivity && inactivity.length > 0);
}

export const DurationDataFields = ({
    allDays, duration, fieldTimeGroup
}) => {
    const { onlyDay, manyDays } = duration;
    const renderOnlyDay = () => {
        const { date, time } = onlyDay;
        const [year, monthIdx, dateNumber] = getDatePartsByMillis(date);
        const day = WEEK_DAYS[new Date(date).getDay()];
        const startString = getTextTimeByMinutes(time.start);
        const endString = getTextTimeByMinutes(time.end);
        return (
            <Column gap="15px">
                <DataField
                    field="Duración"
                    render={
                        <span>
                            <strong>Fecha: </strong>
                            {`${day}, ${dateNumber} de ${MONTHS[monthIdx]} ${year}`}
                        </span>
                    }/>
                <DataField
                    field={fieldTimeGroup || "Hora:"}
                    render={
                        <span>{`${startString} - ${endString}`}</span>
                    }/>
                {(hasInactivity([onlyDay.time]) && onlyDay.time.inactivity.length > 0)
                && <DataField
                    field="Horas de inactividad:"
                    render={
                        <InactivityDataFields
                            time={[{
                                ...onlyDay.time,
                                inactivity: onlyDay.time.inactivity.map(inactivityItem => ({ 
                                    ...inactivityItem, 
                                    date
                                })),
                                dayId: getDayIdByTimestamp(onlyDay.date)
                            }]}
                            allDays={allDays}/>}/>}
            </Column>
        );
    }
    const renderManyDays = () => {
        const { date, time } = manyDays;
        const dateStartParts = getDatePartsByMillis(date.start);
        const dateEndParts = getDatePartsByMillis(date.end);
        const dateWaitlist = date.waitlist > 0 ? getDatePartsByMillis(date.waitlist) : null;
        const dateStr = {
            start: `${dateStartParts[2]} de ${MONTHS[dateStartParts[1]]}`,
            end: `${dateEndParts[2]} de ${MONTHS[dateEndParts[1]]}`,
            waitlist: date.waitlist > 0 ? `${dateWaitlist[2]} de ${MONTHS[dateWaitlist[1]]}` : null
        };
        return (
            <Column gap="15px">
                <DataField
                    field="Duración"
                    render={
                        <PeriodDate>
                            <li><strong>Inicia: </strong>{dateStr.start}</li>
                            <li><strong>Finaliza: </strong>{dateStr.end}</li>
                        </PeriodDate>}
                />
                <DataField 
                    field={fieldTimeGroup}
                    render={
                        <Row gap="35px">
                            {[...time].sort((a, b) => a.dayId - b.dayId).map(({
                                dayId, 
                                start, end
                            }, idx) => {
                                const nameDay = allDays.find(({ id }) => {
                                    return id === dayId;
                                })?.name;
                                const startString = getTextTimeByMinutes(start);
                                const endString = getTextTimeByMinutes(end);
                                return (
                                    <DataField 
                                        key={idx}
                                        field={nameDay}
                                        description={`${startString} - ${endString}`}/>
                                );
                            })}
                        </Row>}/>
                {hasInactivity(time) 
                && <DataField
                    field="Horas de inactividad:"
                    render={<InactivityDataFields
                                time={time}
                                allDays={allDays}/>}/>}
                {date.waitlist > 0  &&
                    <DataField
                        field="Lista de espera"
                        render={
                            <PeriodDate>
                                <li><strong>Fecha límite: </strong>{dateStr.waitlist}</li>
                            </PeriodDate>}
                    />
                }                                
            </Column>
        );
    }
    return (
        <Container>
            {onlyDay ? renderOnlyDay()
            : manyDays && renderManyDays()}
        </Container>
    );
}

export default DurationDataFields;